export const defaultProfileImage =
    "https://www.ihna.edu.au/blog/wp-content/uploads/2022/10/user-dummy.png";
export const defaultPropertyImage = "https://www.w3schools.com/w3images/lights.jpg";